import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { EpimsBankDetailDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-bank-detail-view',
  templateUrl: './bank-detail-view.component.html',
  styleUrls: ['./bank-detail-view.component.css'],
})
export class BankDetailViewComponent implements OnInit {
  @Input() bankDetails: EpimsBankDetailDto[];
  bankForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<EpimsBankDetailDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  selectedBankDetail: any;
  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.bankForm = this.fb.group({ BankDetails: this.fb.array([]) });
    this.setBankDetail();
  }

  clickMe(value) {
    //	console.log('click ', value);
  }

  // method to display banks
  setBankDetail() {
    const control = this.bankForm.controls.BankDetails as FormArray;
    this.bankDetails.forEach((item) => {
      control.push(
        this.fb.group({
          BankName: item.BankName,
          SortCode: item.SortCode,
          BeneficiaryAccountName: item.BeneficiaryAccountName,
          BeneficiaryAccountNumber: item.BeneficiaryAccountNumber,
          Branch: item.Branch,
          Remark: item.Remark,
          BVN: item.BVN,
          id: item.id,
        })
      );
    });
  }

  // method to add Bank
  addBankDetail() {
    const control = this.bankForm.controls.BankDetails as FormArray;
    control.insert(
      0,
      this.fb.group({
        BankName: ['', Validators.required],
        SortCode: ['', Validators.required],
        BeneficiaryAccountName: ['', Validators.required],
        BeneficiaryAccountNumber: ['', Validators.required],
        Branch: ['', Validators.required],
        Remark: [''],
        BVN: [''],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete bank from arrary list
  deleteBankDetail(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.bankForm.controls.BankDetails as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.bankDetails.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.bankDetails[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'bankDetail';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('bankDetail');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
